export const visualBuilderValuesSelector = (propertyId) => (state) => state.visualBuilderValues[propertyId] || {};
